import React from 'react'
import {
    IonContent,
    IonPage,
    IonSelect,
    IonSelectOption,
    useIonViewDidEnter,
} from '@ionic/react'
import './index.css'
import ReactWordcloud from 'react-wordcloud'
import Header from '../../components/Header'
import {
    getGroupStatisticsData,
    getGroupWordCloudData,
} from '../../service/api/dataStatistics'
import { ContactObject, getContacts } from '../../service/api/bot'

type WordCloudListData = { text: string; value: number }[]

const GroupDataStatistics: React.FC<{}> = () => {
    const [day, setDay] = React.useState(7)
    const [groupId, setGroupId] = React.useState('')
    const [groupList, setGroupList] = React.useState<ContactObject[]>([])
    const [groupStatistics, setGroupStatistics] = React.useState({
        total_members_count: 0,
        active_members_count: 0,
        join_members_count: 0,
        leave_members_count: 0,
    })
    const [wordCloudList, setWordCloudList] = React.useState<WordCloudListData>(
        []
    )

    useIonViewDidEnter(() => {
        getContacts({ contacts_type: 'GROUP' }).then((res) =>
            setGroupList(res.wechaty_contacts_list)
        )
    }, [])

    React.useEffect(() => {
        if (day && groupId) {
            getGroupStatisticsData({ groupId, days: day }).then((res) =>
                setGroupStatistics(res)
            )
            getGroupWordCloudData({ groupId, days: day }).then((res) => {
                setWordCloudList(
                    res.topn_words_frequency.reduce((list, cur) => {
                        const keys = Object.keys(cur)
                        list.push({ text: keys[0], value: cur[keys[0]] })
                        return list
                    }, [] as WordCloudListData)
                )
            })
        }
    }, [day, groupId])

    return (
        <IonPage>
            <IonContent className='mybot-content'>
                <Header title='群数据分析' backable></Header>
                <div className='groupDataStatisticsSelectBox'>
                    <div className='groupDataStatisticsSelectItem'>
                        <IonSelect
                            className='groupDataStatisticsDataItemSelect'
                            interface='popover'
                            placeholder='选择日期'
                            onIonChange={(e) => setDay(e.detail.value)}
                            value={day}
                        >
                            <IonSelectOption value={7}>7日</IonSelectOption>
                            <IonSelectOption value={30}>30日</IonSelectOption>
                        </IonSelect>
                    </div>
                    <div className='groupDataStatisticsSelectItem'>
                        <IonSelect
                            className='groupDataStatisticsDataItemSelect'
                            interface='popover'
                            placeholder='选择群'
                            onIonChange={(e) => setGroupId(e.detail.value)}
                            value={groupId}
                        >
                            {groupList.map((item) => (
                                <IonSelectOption
                                    key={item.uid}
                                    value={item.uid}
                                >
                                    {item.name}
                                </IonSelectOption>
                            ))}
                        </IonSelect>
                    </div>
                </div>
                <div className='groupDataStatisticsData'>
                    <div className='groupDataStatisticsDataItem'>
                        <p className='groupDataStatisticsDataTitle'>
                            群成员总数
                        </p>
                        <p>{groupStatistics.total_members_count}</p>
                    </div>
                    <div className='groupDataStatisticsDataItem'>
                        <p className='groupDataStatisticsDataTitle'>活跃人数</p>
                        <p>{groupStatistics.active_members_count}</p>
                    </div>
                    <div className='groupDataStatisticsDataItem'>
                        <p className='groupDataStatisticsDataTitle'>入群人数</p>
                        <p>{groupStatistics.join_members_count}</p>
                    </div>
                    <div className='groupDataStatisticsDataItem'>
                        <p className='groupDataStatisticsDataTitle'>离群人数</p>
                        <p>{groupStatistics.leave_members_count}</p>
                    </div>
                </div>
                <div className='groupDataStatisticsWordCloudBox'>
                    <p className='groupDataStatisticsWordCloudTitle'>
                        词云分析
                    </p>
                    <div className='groupDataStatisticsWordCloud'>
                        <ReactWordcloud
                            words={wordCloudList}
                            options={{
                                colors: [
                                    '#fc5185',
                                    '#3fc1c9',
                                    '#364f6b',
                                    '#ffcef3',
                                    '#cabbe9',
                                    '#a1eafb',
                                ],
                                fontFamily: 'impact',
                                fontSizes: [12, 60],
                                fontStyle: 'normal',
                                fontWeight: 'normal',
                                padding: 1,
                                rotations: 3,
                                rotationAngles: [0, 0],
                                scale: 'log',
                                spiral: 'archimedean',
                                // transitionDuration: 1000,
                            }}
                        />
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default GroupDataStatistics
